import { useMemo } from 'react';
import { AdvertisingLocale, advertisingLocales } from '@amzn/unified-data-table-components/core';
import { useTranslation } from 'react-i18next';

const DEFAULT_UDC_LOCALE = 'en-US';

export const useUDCLocale = (): AdvertisingLocale => {
  const { i18n } = useTranslation();
  return useMemo(() => {
    const matchedLanguageTag = advertisingLocales.filter(locale => i18n.language === locale);
    return matchedLanguageTag.length === 0 ? DEFAULT_UDC_LOCALE : matchedLanguageTag[0];
  }, [i18n.language]);
};
